import {Component, Input, OnInit} from '@angular/core';
import {ControlAction} from "../../../model/broadcast/control";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-power-by',
  templateUrl: './power-by.component.html',
  styleUrls: ['./power-by.component.scss'],
  imports: [
    NgIf
  ],
  standalone: true
})
export class PowerByComponent implements OnInit {

  @Input() ctrl: ControlAction;

  constructor() { }

  ngOnInit(): void {
  }

}
